import { motion } from "framer-motion";

export const HandGesture = ({ showHint }) => {
  if (!showHint) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: [0, 1, 1] }} // smooth fade in only once
      transition={{ duration: 1.5, ease: "easeInOut" }}
      style={{
        position: "absolute",
        left: "50%",
        top: "60%", // slightly lower to imply dragging
        transform: "translate(-50%, -50%)",
        zIndex: 10,
        pointerEvents: "none",
        userSelect: "none",
      }}
    >
      <motion.img
        src="/static/images/handGesture.png" // 👈 transparent PNG from public folder
        alt="Drag Gesture"
        width={130}
        height={130}
        animate={{
          y: [0, -90, 0, 60, 0], // Up → Down → Up
          scale: [1, 0.98, 1, 0.98, 1], // slight pressure feedback
          opacity: [0.85, 1, 0.9, 0.85, 1], // soft shimmer
        }}
        transition={{
          duration: 3.5,
          repeat: Infinity,
          ease: [0.42, 0, 0.58, 1], // smooth cubic bezier
        }}
        style={{
          objectFit: "contain",
          opacity: 0.85,
          filter: "drop-shadow(0 4px 12px rgba(0,0,0,0.15))",
          transformOrigin: "center center",
        }}
      />
    </motion.div>
  );
};
